
















































import { Component, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { ProviderFilter2 } from "@/store/modules/types";

@Component({
  computed: mapState("providers", ["specialties"])
})
export default class ProviderSearch extends Vue {
  @Model("change") readonly filter!: ProviderFilter2;
}
